/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgListBulleted = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 17v2.001H2V17zm18 0v2.001H6v-2zM4 13v2.001H2V13zm18 0v2.001H6v-2zM4 9.001v2H2v-2zm18 0v2H6v-2zM4 5v2.001H2V5zm18 0v2.001H6v-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgListBulleted as ListBulleted };
